import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { springVariants, springViewport } from '../utils/framerVariants'

const YoutubeVideo = ({ data }) => {

  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de/');
  const youtubeVideoId = data.YoutubeIds;
  const srcUrlNoCookie = 'https://www.youtube-nocookie.com/embed/';
  const [showVideo, setShowVideo] = useState(false);
  const playerRef = useRef(null);

  const handleClick = () => {
    setShowVideo(true);
  }; 

  const initializePlyr = () => {
    if (playerRef.current) {
      // eslint-disable-next-line no-undef
      const Plyr = require('plyr');
      new Plyr(playerRef.current);
    }
  };

  useEffect(() => {
    if (showVideo) {
      initializePlyr();
    }
  }, [showVideo]);

  const renderPrivacyBox = () => {
    const title = isGerman ? 'Ein Klick für Datenschutz' : 'One click for data privacy';
    const content = isGerman
      ? 'Erst wenn Sie hier klicken, werden Bilder und andere Daten von Youtube nachgeladen. Ihre IP-Adresse wird dabei an externe Server von Youtube übertragen. Über den Datenschutz dieses Social Media-Anbieters können Sie sich auf der Seite von Youtube informieren.'
      : 'Only when you click the button the video be loaded from Youtube. Only your IP address will be transmitted to external Youtube servers. You can find out more about the data protection of this provider on the Youtube website.';

    return (
      <div className="flex flex-col items-center justify-center text-center border-4 border-black aspect-video px-12 bg-black1">
        <svg xmlns="http://www.w3.org/2000/svg" className="mt-12 md:mt-0 mb-6 w-12 h-12 md:w-16 md:h-16 lg:w-24 lg:h-24" viewBox="0 0 24 24"><path d="M4.652 0h1.44l.988 3.702.916-3.702h1.454l-1.665 5.505v3.757h-1.431v-3.757l-1.702-5.505zm6.594 2.373c-1.119 0-1.861.74-1.861 1.835v3.349c0 1.204.629 1.831 1.861 1.831 1.022 0 1.826-.683 1.826-1.831v-3.349c0-1.069-.797-1.835-1.826-1.835zm.531 5.127c0 .372-.19.646-.532.646-.351 0-.554-.287-.554-.646v-3.179c0-.374.172-.651.529-.651.39 0 .557.269.557.651v3.179zm4.729-5.07v5.186c-.155.194-.5.512-.747.512-.271 0-.338-.186-.338-.46v-5.238h-1.27v5.71c0 .675.206 1.22.887 1.22.384 0 .918-.2 1.468-.853v.754h1.27v-6.831h-1.27zm2.203 13.858c-.448 0-.541.315-.541.763v.659h1.069v-.66c.001-.44-.092-.762-.528-.762zm-4.703.04c-.084.043-.167.109-.25.198v4.055c.099.106.194.182.287.229.197.1.485.107.619-.067.07-.092.105-.241.105-.449v-3.359c0-.22-.043-.386-.129-.5-.147-.193-.42-.214-.632-.107zm4.827-5.195c-2.604-.177-11.066-.177-13.666 0-2.814.192-3.146 1.892-3.167 6.367.021 4.467.35 6.175 3.167 6.367 2.6.177 11.062.177 13.666 0 2.814-.192 3.146-1.893 3.167-6.367-.021-4.467-.35-6.175-3.167-6.367zm-12.324 10.686h-1.363v-7.54h-1.41v-1.28h4.182v1.28h-1.41v7.54zm4.846 0h-1.21v-.718c-.223.265-.455.467-.696.605-.652.374-1.547.365-1.547-.955v-5.438h1.209v4.988c0 .262.063.438.322.438.236 0 .564-.303.711-.487v-4.939h1.21v6.506zm4.657-1.348c0 .805-.301 1.431-1.106 1.431-.443 0-.812-.162-1.149-.583v.5h-1.221v-8.82h1.221v2.84c.273-.333.644-.608 1.076-.608.886 0 1.18.749 1.18 1.631v3.609zm4.471-1.752h-2.314v1.228c0 .488.042.91.528.91.511 0 .541-.344.541-.91v-.452h1.245v.489c0 1.253-.538 2.013-1.813 2.013-1.155 0-1.746-.842-1.746-2.013v-2.921c0-1.129.746-1.914 1.837-1.914 1.161 0 1.721.738 1.721 1.914v1.656z"/></svg>
        <h2 className="text-headline-md tracking-headline-md leading-headline-md font-bold mb-4">{title}</h2>
        <p className="mb-8 max-w-2xl">{content}</p>
        <button
        onClick={handleClick}
        type="button"
        className="inline-flex items-center gap-x-4 bg-black px-6 pt-[12px] pb-[14px] mb-12 md:mb-0 text-text tracking-text-sm font-semibold text-white shadow-sm hover:bg-black/20 hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black/60 transition-color duration-200"
      >
        {isGerman ? 'Video laden' : 'Load Video'}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="relative top-[2px] -mr-0.5 h-5 w-5">
          <path fillRule="evenodd" d="M4.755 10.059a7.5 7.5 0 0112.548-3.364l1.903 1.903h-3.183a.75.75 0 100 1.5h4.992a.75.75 0 00.75-.75V4.356a.75.75 0 00-1.5 0v3.18l-1.9-1.9A9 9 0 003.306 9.67a.75.75 0 101.45.388zm15.408 3.352a.75.75 0 00-.919.53 7.5 7.5 0 01-12.548 3.364l-1.902-1.903h3.183a.75.75 0 000-1.5H2.984a.75.75 0 00-.75.75v4.992a.75.75 0 001.5 0v-3.18l1.9 1.9a9 9 0 0015.059-4.035.75.75 0 00-.53-.918z" clipRule="evenodd" />
        </svg>
      </button>
      </div>
    );
  };

  const renderVideoPlayer = () => (
    <div className="player-wrap">
      <div className="plyr__video-embed relative" id="player">
        <iframe
          className="aspect-16/9"
          ref={playerRef}
          src={`${srcUrlNoCookie}${youtubeVideoId}`}
          allowFullScreen
          allowTransparency
          allow="autoplay"
        ></iframe>
      </div>
    </div>
  );

  return (
    <motion.article
      variants={springVariants} initial="invisible" whileInView="visible" viewport={springViewport}
      className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-0 md:px-24 lg:px-24 xl:px-24 relative">
      {showVideo ? renderVideoPlayer() : renderPrivacyBox()}
      {data.VideoCaption && <p className="inline-flex px-4 sm:px-8 md:px-0 mt-4 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50 max-w-xl">{data.VideoCaption}</p>}
    </motion.article>
  );
};

export default YoutubeVideo;
